import { Capacitor } from '@capacitor/core';

// Single source of truth for the backend base URL.
//
// Native (iOS/Android): the web assets are bundled inside the app and loaded
// from a local Capacitor origin (capacitor://localhost), so the app MUST call
// the backend by an absolute URL baked in at build time. Production iOS builds
// set REACT_APP_BACKEND_URL=https://api.fitxess.com.
//
// Web: the SPA is served BY the backend itself (same Cloud Run container), so
// it uses SAME-ORIGIN requests. This is what lets one built image work on the
// temporary *.run.app host before DNS and on https://api.fitxess.com after
// cutover with NO rebuild — the SPA always talks to whatever host served it.
export const BACKEND_BASE_URL = Capacitor.isNativePlatform()
  ? (process.env.REACT_APP_BACKEND_URL || '')
  : '';

// Absolute origin for full-page navigations (e.g. OAuth initiation), where a
// bare relative path also works but an explicit origin reads clearer. On web
// this is the current origin (same-origin); on native it's the baked URL.
export function backendOrigin() {
  if (Capacitor.isNativePlatform()) {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  return window.location.origin;
}
